import {
  ColorSchemeProvider,
  MantineProvider,
} from "@mantine/core";
import { useHotkeys } from "@mantine/hooks";
import { Notifications } from "@mantine/notifications";
import {
  createHashHistory,
  ReactLocation,
  Router,
} from "@tanstack/react-location";
import { ChatRoute } from "../routes/ChatRoute";
import { IndexRoute } from "../routes/IndexRoute";
import { Layout } from "./Layout";
import { useEffect } from "react";
import { ensureProvidersLoaded } from "../providers/loader";
import { ThemeProvider, useTheme } from "../utils/themeContext";

// Initialize the router
const history = createHashHistory();
const location = new ReactLocation({ history });

// App wrapper that provides theme context
export function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

// Main app content that uses theme context
function AppContent() {
  const { colorScheme, toggleColorScheme, theme } = useTheme();
  
  // Keyboard shortcut for toggling color scheme
  useHotkeys([["mod+J", () => toggleColorScheme()]]);

  // Ensure providers are loaded
  useEffect(() => {
    // This will trigger the import of all providers
    const providerCount = ensureProvidersLoaded();
    console.log(`Loaded ${providerCount} providers`);
  }, []);

  return (
    <Router
      location={location}
      routes={[
        { path: "/", element: <IndexRoute /> },
        { path: "/chats/:chatId", element: <ChatRoute /> },
      ]}
    >
      <ColorSchemeProvider
        colorScheme={colorScheme}
        toggleColorScheme={toggleColorScheme}
      >
        <MantineProvider
          withGlobalStyles
          withNormalizeCSS
          withCSSVariables
          theme={theme}
        >
          <Layout />
          <Notifications />
        </MantineProvider>
      </ColorSchemeProvider>
    </Router>
  );
}
